
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/forgot-password",
      function () {
        return require("private-next-pages/[brand]/forgot-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/forgot-password"])
      });
    }
  